import React from 'react';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import GroupIcon from '@material-ui/icons/Group';
import RoomIcon from '@material-ui/icons/Room';
import logo from '../../assets/png/flynote_blue.png';

const stats = [
  {
    icon: <StarBorderIcon style={{ color: '#A685E2', fontSize: 20 }} />, // purple
    bg: '#F0EAFE',
    value: '4.7',
    label: 'Google Rating',
    valueColor: '#3CB4E7',
  },
  {
    icon: <GroupIcon style={{ color: '#F4A261', fontSize: 20 }} />, // orange
    bg: '#FEF1E6',
    value: '1 Lac +',
    label: 'Travelers',
    valueColor: '#3CB4E7',
  },
  {
    icon: <RoomIcon style={{ color: '#3CB4E7', fontSize: 20 }} />, // blue
    bg: '#EAF2F2',
    value: '40+',
    label: 'Destinations',
    valueColor: '#3CB4E7',
  },
];

const FlynoteStats = () => (
  <section
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',      
      minHeight: 80,
      width: 'auto',
      background: 'transparent',
      marginTop: 32,
      marginBottom: 0,
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
      }}
    >
      <img src={logo} alt="Flynote logo" style={{ height: 32, marginRight: 12 }} />
      <span style={{
        color: 'rgb(50, 48, 44)', fontWeight: 400, fontSize: 14, fontFamily: 'Sofia-pro, sans-serif', 
      }}
      >
        India&apos;s favorite vacations platform
      </span>
    </div>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 32,
      }}
    >
      {stats.map((stat) => (
        <div
          key={stat.label}
          style={{ display: 'flex', alignItems: 'center', gap: 12 }}
        >
          <span
            style={{
              background: stat.bg,
              borderRadius: 12,
              width: 36,
              height: 36,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {stat.icon}
          </span>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <span
              style={{
                color: '#0090B5',
                fontSize: 16,
              }}
            >
              {stat.value}
            </span>
            <span
              style={{
                color: '#666',
                fontWeight: 400,
                fontSize: 14,
                fontFamily: 'Sofia-pro, sans-serif',
              }}
            >
              {stat.label}
            </span>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default FlynoteStats; 
